import 'iframe-resizer/js/iframeResizer.contentWindow.min';
import { includes } from 'lodash';
import store from '@/store';

const init = () => new Promise((resolve) => {
  /*
    this one might be unnecessary since it is regular post message listener,
    same as one in postMessage.js but i will leave it for now in case of some specific
    messages such as "resize", etc.
    */
  window.addEventListener('message', (message) => {
    if (includes(store.getters.allowedOrigins, message.origin)) {
      // do necessary work
    }
  });
  resolve();
});
const iFrameResizerSendMessage = (message) => {
  if ('parentIFrame' in window) window.parentIFrame.sendMessage(message);
  else {
    // console.error('iFrameResizer not available');
  }
};

export { init, iFrameResizerSendMessage };
